import { FormBase } from "core/components";

export default class ProductEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "itemId",
                    label: "PRODUCT.EDIT.ITEMID_LABEL",
                    placeholder: "PRODUCT.EDIT.ITEMID_PLACEHOLDER",
                    rules: "string|required",
                },
                {
                    name: "description",
                    label: "PRODUCT.EDIT.DESCRIPTION_LABEL",
                    placeholder: "PRODUCT.EDIT.DESCRIPTION_PLACEHOLDER",
                    type: "textarea",
                    rules: "string|required",
                },
                {
                    name: "alternativeName",
                    label: "PRODUCT.EDIT.ALTERNATIVE_NAME_LABEL",
                    placeholder: "PRODUCT.EDIT.ALTERNATIVE_NAME_LABEL",
                    type: "textarea",
                    rules: "string",
                },
                {
                    name: "units",
                    label: "PRODUCT.EDIT.UNITS_LABEL",
                    placeholder: "PRODUCT.EDIT.UNITS_PLACEHOLDER",
                    type: "number",
                    rules: ["required", "min:0.01"],
                },
                {
                    name: "unitOfMeasureId",
                    label: "PRODUCT.EDIT.UOM_LABEL",
                    placeholder: "PRODUCT.EDIT.UOM_PLACEHOLDER",
                    rules: "string|required",
                },
                {
                    name: "uom",
                    label: "PRODUCT.EDIT.UOM_LABEL",
                    placeholder: "PRODUCT.EDIT.UOM_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "calsPerMl",
                    label: "PRODUCT.EDIT.CALSPERML_LABEL",
                    placeholder: "PRODUCT.EDIT.CALSPERML_PLACEHOLDER",
                    type: "number",
                    rules: "required",
                },
                {
                    name: "itemCategoryId",
                    label: "PRODUCT.EDIT.ITEM_CATEGORY_LABEL",
                    placeholder: "PRODUCT.EDIT.ITEM_CATEGORY_PLACEHOLDER",
                    rules: "string|required",
                },
                {
                    name: "subCategoryId",
                    label: "PRODUCT.EDIT.SUB_CATEGORY_LABEL",
                    placeholder: "PRODUCT.EDIT.SUB_CATEGORY_PLACEHOLDER",
                    rules: "string|required",
                },
                {
                    name: "procedureCodeId",
                    label: "PRODUCT.EDIT.PROCEDURE_CODE_LABEL",
                    placeholder: "PRODUCT.EDIT.PROCEDURE_CODE_PLACEHOLDER",
                    type: "string",
                    rules: "required"
                },
                {
                    name: "caloriesPerContainer",
                    label: "PRODUCT.EDIT.CALORIES_PER_CONTAINER_LABEL",
                    placeholder:
                        "PRODUCT.EDIT.CALORIES_PER_CONTAINER_PLACEHOLDER",
                    type: "integer",
                },
                {
                    name: "billableToMedicare",
                    type: "bool",
                    value: false,
                },
                {
                    name: "isActive",
                    type: "bool",
                    value: false,
                },
                {
                    name: "isPreferred",
                    type: "bool",
                    value: false,
                },
                {
                    name: "qtyPerCase",
                    label: "PRODUCT.EDIT.QTY_PER_CASE_LABEL",
                    placeholder: "PRODUCT.EDIT.QTY_PER_CASE_PLACEHOLDER",
                    type: "integer",
                },
                {
                    name: "defaultQuantity",
                    label: "PRODUCT.EDIT.DEFAULT_QUANTITY_LABEL",
                    placeholder: "PRODUCT.EDIT.DEFAULT_QUANTITY_PLACEHOLDER",
                    type: "integer",
                },
                {
                    name: "mlsPerContainer",
                    label: "PRODUCT.EDIT.MLS_PER_CONTAINER_LABEL",
                    placeholder: "PRODUCT.EDIT.MLS_PER_CONTAINER_PLACEHOLDER",
                    type: "integer",
                },
                {
                    name: "amountOfUnitsToSend",
                    label: "PRODUCT.EDIT.UNITS_TO_SEND_LABEL",
                    placeholder: "PRODUCT.EDIT.UNITS_TO_SEND_PLACEHOLDER",
                    type: "integer",
                },
                {
                    name: "mcrallowable",
                    label: "PRODUCT.EDIT.MCR_ALLOWABLE_LABEL",
                    placeholder: "PRODUCT.EDIT.MCR_ALLOWABLE_PLACEHOLDER",
                    type: "string",
                },
                {
                    name: "containerSize",
                    label: "PRODUCT.EDIT.CONTAINER_SIZE_LABEL",
                    placeholder: "PRODUCT.EDIT.CONTAINER_SIZE_PLACEHOLDER",
                    type: "string",
                },
                {
                    name: "notes",
                    label: "PRODUCT.EDIT.NOTES_LABEL",
                    placeholder: "PRODUCT.EDIT.NOTES_PLACEHOLDER",
                    type: "string",
                },
                {
                    name: "itemTypeId",
                    label: "PRODUCT.EDIT.ITEM_TYPE_LABEL",
                    placeholder: "PRODUCT.EDIT.ITEM_TYPE_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "innerCannulaId",
                    label: "PRODUCT.EDIT.INNER_CANNULA_LABEL",
                    placeholder: "PRODUCT.EDIT.INNER_CANNULA_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "defaultItemTypeId",
                    label: "PRODUCT.EDIT.PRODUCT_TYPE_LABEL",
                    placeholder: "PRODUCT.EDIT.PRODUCT_TYPE_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "pumpBrandId",
                    label: "PRODUCT.EDIT.PUMP_BRAND_LABEL",
                    placeholder: "PRODUCT.EDIT.PUMP_BRAND_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "specialtyTypeId",
                    label: "PRODUCT.EDIT.SPECIALTY_TYPE_LABEL",
                    placeholder: "PRODUCT.EDIT.SPECIALTY_TYPE_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "parentProductId",
                    label: "PRODUCT.EDIT.PARENT_PRODUCT_LABEL",
                    placeholder: "PRODUCT.EDIT.PARENT_PRODUCT_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "height",
                    label: "Height",
                    placeholder: "Enter height",
                    type: "number",
                },
                {
                    name: "width",
                    label: "Width",
                    placeholder: "Enter width",
                    type: "number",
                },
                {
                    name: "heightMeasurementUnitId",
                    label: "Height Measurement",
                    placeholder: "Select measurement unit",
                    rules: "string",
                },
                {
                    name: "widthMeasurementUnitId",
                    label: "Width Measurement",
                    placeholder: "Select measurement unit",
                    rules: "string",
                },
                {
                    name: "woundCareItemSubCategoryId",
                    label: "Wound Care Subcategory",
                    placeholder: "Select Wound Care Subcategory",
                    rules: "string"
                },
                {
                    name: 'productTagIds',
                    label: 'PRODUCT_TYPE.EDIT.TAGS_LABEL',
                    placeholder: 'PRODUCT_TYPE.EDIT.TAGS_PLACEHOLDER'
                },
                {
                    name: 'vendorId',
                    label: 'Vendor',
                    placeholder: 'Select Vendor',
                },
                {
                    name: 'isSAPs',
                    type: "bool",
                    value: false,
                },
                 {
                    name: 'backordered',
                    type: "bool",
                    value: false,
                },
            ],
        };
    }
}
